<template>
    <div class="w-100">
        <button id="c-button--slide-bottom" class="c-button btn btn-light allBoxShadows">
            <i class="fa fa-bars faIcons"></i>
        </button>
        <nav id="c-menu--slide-bottom" class="c-menu c-menu--slide-bottom">
            <button class="c-menu__close allBoxShadows">
                <i class="fa fa-times faTimesIcons d-block"></i>
            </button>
            <div class="BottomMenuItems text-center eachItem">
                <swiper class="swiper" :options="swiperOption">
                    <swiper-slide
                            class="list-group-item list-group-item-action border-0 rounded-0 pt-4 position-relative"
                            :class="{'bg-primary text-light' : ($parent.currentMenuId === item.id), 'disabled': item.id > 4}"
                            v-for="item in menuItems"
                            @click.native="item.id <= 4 ? changeCategory(item.id) : null"
                            :key="item.id">
                        <img class="menuImageItems d-inline-block m-auto" :src="item.image">
                        <span class="font-weight-bold mr-2"> {{ item.title }} </span>
                        <span v-if="item.id > 4" class="badge badge-warning soon-badge">به زودی</span>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </nav>
        <div id="c-mask" class="c-mask"></div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import Menu from '@/assets/js/menu';

    let slideBottom;

    export default {
        name: "BottomNavBar",
        props: ["menuItems"],
        components: {
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                swiperOption: {
                    navigation: {
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next'
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 6
                        },
                        768: {
                            slidesPerView: 4
                        },
                        500: {
                            slidesPerView: 3
                        },
                        320: {
                            slidesPerView: 2
                        }
                    }
                }
            }
        },
        mounted() {
            slideBottom = new Menu({
                wrapper: '#o-wrapper',
                type: 'slide-bottom',
                menuOpenerClass: '.c-button',
                maskId: '#c-mask'
            });
            let slideBottomBtn = document.getElementById("c-button--slide-bottom");
            slideBottomBtn.addEventListener('click', function(e) {
                e.preventDefault();
                slideBottom.open();
            });
        },
        methods: {
            changeCategory: function (id) {
                slideBottom.close();
                if (this.$parent.currentMenuId === id) {
                    return;
                }
                let loader = this.$loading.show();
                this.$parent.currentMenuId = id;

                // Clear Notification Area
                this.$parent.notificationsCount = 0;
                document.getElementById("notifications-body").innerHTML = "";
                this.$parent.toastsQueue = [];
                this.$parent.initMapByCategoryId(id);
                loader.hide();
                this.$parent.fixUrlByCategoryId(id);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/css/tokens";

    .eachItem {
        position: absolute;
        left: 0;
        right: 0;
        height: 100px !important;
        background-color: $bg-card;
        padding-left: 60px;
        cursor: pointer;
        background-image: $gradient-main;
        background-repeat: no-repeat;
        background-size: 100% 3px;
        background-position: top;
    }

    .menuImageItems {
        width: 50px;
        height: 50px;
        margin: -2px auto 4px !important;
    }
</style>

<style lang="scss" scoped>
    @import '../../../node_modules/swiper/css/swiper.min.css';
    @import "@/assets/css/tokens";

    .swiper-container {
        height: 100% !important;
    }

    .faIcons {
        transform: translate(1.5px, 3.5px);
        font-size: 30px;
        width: auto;
        height: 1.6em;
        color: $text-secondary;
    }

    .faTimesIcons {
        transform: translate(5.2px, 4.5px);
        font-size: 30px;
        width: auto;
        height: 1.5em;
    }

    .swiper-button-prev:after {
        padding: 10px 12px !important;
        border-radius: 10px 0 0 10px;
        background-color: $bg-card;
    }

    .swiper-button-next:after {
        padding: 10px 12px !important;
        border-radius: 0 10px 10px 0;
        background-color: $bg-card;
    }

    #c-button--slide-bottom {
        position: absolute;
        z-index: 1;
        left: 10px;
        bottom: 10px;
        width: 50px;
        height: 50px;
    }

    .disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .soon-badge {
        position: absolute;
        top: 12px;
        left: 25px;
        background: rgba($accent-purple, 0.12);
        color: $accent-purple;
        border: 1px solid rgba($accent-purple, 0.25);
        padding: 3px 8px;
        border-radius: 8px;
        font-size: 11px;
        font-weight: 700;
    }
</style>
